<div class="ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-dialog-header">
    <h2 langkey="phSelectedLayer_Title">

    </h2>
  </div>
  <div class="ya-dialog-content">
    <div class=select-dialog-location-description>
      <span langkey="phSelectedLayer_Description"></span>
    </div>
    <ng-container *ngFor="let location of locations; let i = index">
      <a matRipple matRippleCentered="true" (click)="selectLocation(location)">
        <div ngClass="ya-dialog-list-item">
          <div class="select-dialog-location-content">
            <h3>{{location.label}}</h3>
            <span>{{location.street}}</span>
            <span>{{location.zip}} {{location.PostalCode}}</span>
          </div>
          <div class="select-dialog-item-action">
            <ng-container *ngIf="location.like">
              <div class="inline-icon ya-favorite-svg likefiller" inlineSVG="shop-icons.svg#ya-favorite"></div>
            </ng-container>
          </div>
        </div>
      </a>
    </ng-container>
  </div>
</div>